import {useLocation} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../style/home.css';
import Iframe from "./Iframe";

const Chart = () => {

    let location = useLocation();
    let url = location.state.url;
    
    return (<>
            <div className="RootView">
                <div className="RootWidth">

                    <div className="loginDiv">


                        <div className="toolbar">
                            <div>
                                <img src="../images/back.png"  onClick={()=>{window.history.go(-1)}} style={{padding: "5px"}}/>
                                <span>Chart</span>
                            </div>


                        </div>

                        <div style={{background:"#f1f1f1"}}>
                            <Iframe source={url} />
                        </div>
                        
                    </div>


                </div>
            </div>


        </>
    );
};

export default Chart;
